export default {
    pageTitle: '登录',
    confirm: '确认',
    cancel: '取消',
    loginPage: {
        qsrsjhm: '请输入手机号码',
        hqyzm: '获取验证码',
        wyydty: '我已阅读并同意',
        yhxy: '用户协议',
        yssm: '隐私声明',
        dlkf: '内地客服',
        xgkf: '香港客服',
        qydbgxyhxy: '请阅读并勾选用户协议、隐私声明',
        yzmfssb: '验证码发送失败',
        repeatTips: '60s内无须重复获取验证码',
        请输入正确的手机号: '请输入正确的手机号',
        loginTitle: '登录/注册',
        loginDesc: '首次登录自动注册财富管理账号',
        invitationCode: '邀请码',
        invitationCodeInputHint: '请输入邀请码，字母或数字',
    },
    sendPage: {
        srdxyzm: '输入短信验证码',
        yfsdxyzmz: '已发送短信验证码至：',
        cxfs: '重新发送',
        sbdyzm: '收不到验证码',
        nkylxkfjxyzmcx: '您可以联系客服进行验证码查询。',
        dlkf: '内地客服：',
        xgkf: '香港客服：',
        qsrzqdyzmzsyc: '验证码错误或失效，请重新输入',
        zdl: '知道了',
        获取语音验证码: '获取语音验证码',
        '我们将通过电话语音告知您验证码，请留意接听。': '我们将通过电话语音告知您验证码，请留意接听。',
        '如仍无法收到，可': '如仍无法收到，可',
        联系客服: '联系客服',
        '语音验证码已发送，请留意接听电话': '语音验证码已发送，请留意接听电话',
        重新获取: '重新获取',
        输入语音验证码: '输入语音验证码',
        我们正在打电话至: '我们正在打电话至：',
        电话将提供验证码: '，电话将提供验证码',
        '语音验证码获取频率过高，请稍后再试': '语音验证码获取频率过高，请稍后再试',
        联系我们: '联系我们',
    },
    Country: {
        qsrdqgjzss: '请输入地区关键字搜索',
        cydq: '常用地区',
    },
    fxhlzq: '复星国际证券',
    已了解: '已了解',
    '系统识别该手机号已绑定交易账户。': '系统识别该手机号已绑定交易账户。',
    '为保障您的账户安全，该类型账户暂不支持网页登录，前往': '为保障您的账户安全，该类型账户暂不支持网页登录，前往',
    下载或打开星财富APP: '下载或打开星财富APP',
    '，登录您的账户。': '，登录您的账户。',
    resetPwdTips1: '系统识别到当前手机号绑定多个交易账户。为保障您的账户安全，暂不支持通过网页重置交易密码。 如有需要，请联系我们。',
    resetPwdTips2: '系统识别到当前手机号尚未完成交易账户绑定。暂不支持重置交易密码。 如有疑问，请联系我们。',
    resetPwdTips3: '系统识别到当前手机号已绑定交易账户，为保障您的账户安全，该类型账户暂不支持重置交易密码。 如有疑问，请联系我们。',
    ryLoginTips1: '系统识别到当前手机号绑定多个交易账户，为保障您的账户安全，该类型账户暂不支持站外登录。 如有疑问，请联系我们。',
    ryLoginTips2: '系统识别到当前手机号已绑定交易账户，为保障您的账户安全，该类型账户暂不支持站外登录。 如有疑问，请联系我们。',
    FosunSecuritiesDisclaimer: `复星国际证券提供的所有资管产品均由第三方机构管理，复星国际证券不对产品业绩做任何保证。本平台提供数据及信息均来源于公开资料或经外部授权信息的分析和整理，
    复星国际证券发布此信息的目的在于传播更多信息，与本平台立场无关，相关表述仅供参考，不代表任何确定性判断，亦不构成复星国际证券的任何推荐或投资建议。
    对于本平台所发布的所有产品资料及净值数据等信息，虽复星国际证券尽力保证数据的准确性、真实性、完整性、有效性、及时性，但投资者仍然须以中国证监会资本市场电子化信息披露平台、
    基金管理人官方网站及其委托的基金估值核算机构发布的信息为准，并且在做好充分的研究后，以自身研究结果为依据，审慎独立地作出投资决策。
    本平台所载文章、数据仅供参考，使用前请核实，风险自负。`,
    inviteFriends: '邀请好友',
    inviteList: '邀请明细',
    inviteActivityList: '邀请好友',
    searchInviteActivityList: '邀请好友',
    我的邀请码: '我的邀请码',
    立即邀请: '立即邀请',
    立即绑定: '立即绑定',
    修改: '修改',
    已绑定: '已绑定',
    '您当前已完成注册，不能绑定注册邀请关系': '您当前已完成注册，不能绑定注册邀请关系',
    '您当前已完成开户，不能绑定开户邀请关系': '您当前已完成开户，不能绑定开户邀请关系',
    '您当前已完成首次入金，不能绑定入金邀请关系': '您当前已完成首次入金，不能绑定入金邀请关系',
    暂无注册邀请人: '暂无注册邀请人',
    暂无入金邀请人: '暂无入金邀请人',
    暂无开户邀请人: '暂无开户邀请人',
    注册邀请人: '注册邀请人',
    开户邀请人: '开户邀请人',
    入金邀请人: '入金邀请人',
    绑定邀请人: '绑定邀请人',
    修改邀请人: '修改邀请人',
    '请输入邀请码，字母或数字': '请输入邀请码，字母或数字',
    '邀请码为6位数，包含数字或大写字母': '邀请码为6位数，包含数字或大写字母',
    暂无您填写的邀请码: '暂无您填写的邀请码',
    您的开户邀请人更新为: '您的开户邀请人更新为',
    您的入金邀请人更新为: '您的入金邀请人更新为',
    星财号: '星财号',
    绑定成功: '绑定成功',
    修改成功: '修改成功',
    绑定失败: '绑定失败',
    修改失败: '修改失败',
    邀请码: '邀请码',
    邀请人更新确认: '邀请人更新确认',
    不能绑定自己为邀请人: '不能绑定自己为邀请人',
    invitee: {
        searchPlaceholder: '请输入昵称/星财号/手机号',
        copySuccess: '已复制',
        copyFail: '复制失败',
        loading: '加载中',
        relationChanged: '邀请关系变更',
        emptyTips: '暂无受邀用户，快去邀请好友',
        gotIt: '我知道了',
        noMore: '没有更多了',
        status: {
            registered: '已注册',
            opened: '已开户',
            notOpened: '开户',
            deposited: '已入金',
            qualified: '资产达标',
        },
        profile: {
            myInvites: '我的邀请',
            viewDetail: '查看明细',
            assetQualified: '资产达标',
            assetQualifiedExplain: '资产达标说明',
            assetQualifiedDesc: '资产达标数据于每天 00:00 定时更新。净入金 = 转入金额 + 转入持仓 - 转出金额 - 转出持仓。',
        },
    },
    inviteActivity: {
        shareInviteLink: '分享邀请链接',
        rule: '活动细则',
        cashRewardTitle1: '最高领8500',
        cashRewardTitle2: '现金券奖励',
        cashRewardDescription1: '活动期间内邀请达标5个及以内，奖励200HKD/人；邀请达标6个及以上，最高奖励500HKD/人',
        cashRewardDescription2: '最高可邀请20人',
        riskTips: '投资涉及风险，优惠受条款约束，详情请参阅活动细则',
        shareTextTitle: '邀请你来星财富体验',
        shareTextTitle1: '香港最全投资品类科技券商服务——',
        shareTextPoint1: '1.真正的港美股期权一世免佣',
        shareTextPoint2: '2.港股LV2实时行情',
        shareTextPoint3: '3.多元化资产配置服务',
        shareTextFooter: '现在入资即可领奖，请确保入资前已绑定邀请关系，点击下方链接参与活动：',
        viewMyInvite: '查看我的邀请',
    },
}
